module.exports = __webpack_public_path__ + "static/media/Howard, Burlingame, CA2.9f8a6abb.jpg";